import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="bg-white pt-[80px] pb-10 md:pt-36 md:pb-24 px-4 overflow-hidden" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-[24px] pt-[20px] pb-[20px] text-center" data-id="element-149">
          <div className="inline-block bg-primary/10 text-primary font-bold px-4 py-1.5 rounded-full text-sm" data-id="element-150">
            Sistema Mamá IA
          </div>

          <div className="space-y-4" data-id="element-151">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-152">
              Crea y vende tu primer PDF en 7 días usando solo tu celular
            </h1>

            <p className="text-xl md:text-2xl text-slate-500 leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-153">
              El primer método diseñado para mamás latinas que utiliza{' '}
              <strong className="text-dark" data-id="element-154">Inteligencia Artificial</strong>{' '}
              para crear, diseñar y lanzar un producto digital en una fracción
              del tiempo habitual.
            </p>
          </div>

          <div className="pt-4 space-y-3" data-id="element-155">
            <motion.a href="#oferta" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            document.getElementById('oferta')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="shimmer-cta inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-bold rounded-2xl px-8 py-5 text-lg md:text-xl shadow-lg shadow-primary/25 text-center relative overflow-hidden cursor-pointer" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-156">
              ¡Lanza Tu Negocio En 7 Días! 🚀
            </motion.a>
            <p className="text-slate-500 text-center font-semibold text-[14px]" data-id="element-157">
              PAGO ÚNICO - SIN SUSCRIPCIONES
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="pt-6" data-id="element-158">
            <img src="https://cdn.magicpatterns.com/uploads/1MnqNQ3nc67ACgswXzsUXc/portada.webp" alt="Sistema Mamá IA - Tu Negocio Digital en 48 Horas" className="w-full max-w-2xl mx-auto rounded-2xl shadow-2xl shadow-primary/10" data-id="element-159" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}